
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sso-sign",
      function () {
        return require("private-next-pages/sso-sign.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sso-sign"])
      });
    }
  